











































































import { User } from "@/store/modules/types";
import { Component, Vue } from "vue-property-decorator";
import Swal from 'sweetalert2'

@Component
export default class Login extends Vue {
  username = "";
  password = "";
  otpCode = "";
  async setDefaultWList(){
    await this.$store.dispatch("schedule/getWaitingList");
    var list = this.$store.state.schedule.waitingList;
    
    if(list.length){
      this.$store.state.schedule.checkingList = list[0];
      return true;
    }else{
      return false;
    }
  }
  async login() {
    const { username, password } = this;
    if (!username || !password) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      var user: User = await this.$store.dispatch("auth/login", {
        username,
        password,
      });

      if(user.message ==="CODE_SENT"){
        this.$store.commit("main/SET_LOADING", false);
            const result = await this.askForCodeAndValidate(this);

        if (result.isConfirmed && result.value){
         user = result.value        
        }else{
          return;
        }
     
      }

      if(user.mustChangePassword){
        const data = await this.$store.dispatch("auth/requestPasswordChange");
        const publicId =data["publicId"];
        this.$router.push({ name: "pwd_verify", params: { publicId: publicId }  });
        return;
      }

      const {
        DEFAULT_MODULE,
        ENABLE_GAPS_MODULE,
        ENABLE_SCHEDULE_MODULE,
        ENABLE_CASES_MODULE,
        ENABLE_PATIENTS_MODULE,
        ENABLE_PROVIDERS_MODULE,
        ENABLE_CALLS_MODULE,
        ENABLE_CHECKIN_MODULE,
        ENABLE_FILES_MODULE
      } = user.settings;
      if (DEFAULT_MODULE) {
        switch (DEFAULT_MODULE.toUpperCase()) {
          case "GAPS":
            if (ENABLE_GAPS_MODULE)
              this.$router.push({ name: "gap-dashboard" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Gaps</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "CHECKIN":
            if (ENABLE_CHECKIN_MODULE){
              const isDefault = await this.setDefaultWList();
              
              if(isDefault){
                this.$router.push({ name: "checkin" });
              }else{
                this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Check-in</b> does not have a <b>list</b>.",
              });
              }
            }
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Check In</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "SCHEDULE":
            if (ENABLE_SCHEDULE_MODULE) this.$router.push({ name: "schedule" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Schedule</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "FILES":
            if (ENABLE_FILES_MODULE) this.$router.push({ name: "files" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Files</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "CASES":
            if (ENABLE_CASES_MODULE) this.$router.push({ name: "cases" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Cases</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "PATIENTS":
            if (ENABLE_PATIENTS_MODULE) this.$router.push({ name: "patients" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Patients</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "PROVIDERS":
            if (ENABLE_PROVIDERS_MODULE)
              this.$router.push({ name: "providers" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Providers</b> module not <b>enabled</b>.",
              });
            }
            break;
          case "CALLS":
            if (ENABLE_CALLS_MODULE) this.$router.push({ name: "calls" });
            else {
              this.$modal.show("dialog", {
                title: "WaitingMed",
                text: "<b>Calls</b> module not <b>enabled</b>.",
              });
            }
            break;
        }
      } else {
        if (ENABLE_CHECKIN_MODULE) {
          this.$router.push({ name: "checkin" });
        }else if (ENABLE_FILES_MODULE) {
          this.$router.push({ name: "files" });
        } 
        else if (ENABLE_GAPS_MODULE) {
          this.$router.push({ name: "gap-dashboard" });
        } else if (ENABLE_SCHEDULE_MODULE) {
          this.$router.push({ name: "schedule" });
        } else if (ENABLE_CASES_MODULE) {
          this.$router.push({ name: "cases" });
        } else if (ENABLE_PATIENTS_MODULE) {
          this.$router.push({ name: "patients" });
        } else if (ENABLE_PROVIDERS_MODULE) {
          this.$router.push({ name: "providers" });
        } else if (ENABLE_CALLS_MODULE) {
          this.$router.push({ name: "calls" });
        } else {
          this.$modal.show("dialog", {
            title: "WaitingMed",
            text: "You have no <b>enabled</b> modules.",
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
      this.password = "";
    }
  }

  async askForCodeAndValidate(context) {
    return await Swal.fire({
      title: "Verification",
      html: `
      <div style="text-align:center;">
        <i class="fas fa-lock fa-3x" style="color:#3085d6; margin-bottom:15px;"></i>
        <p>
        A verification code has been sent to your email or phone number.
      <br><br>
        Please check your inbox or SMS/WhatsApp messages and enter the code below to continue.
      </p>
      </div>
    `,
      input: "number",
      inputLabel: "Enter verification code" as string,
      inputValue: context.otpCode || "",
      showCancelButton: true,
      confirmButtonText: "Verify" as string,
      cancelButtonText: "Cancel" as string,
      confirmButtonColor: "#1bacbe",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async (code) => {
        if (!code) {
          Swal.showValidationMessage("You need to enter the code!" as string);
          return false;
        }

        try {
          /*
          const retryParams = new FormData();
          retryParams.append("publicId", context.publicId);
          retryParams.append("birthdate", context.birth.date);
          if (context.phone) retryParams.append("phone", context.phone);
          if (context.requisition) retryParams.append("requisition", context.requisition);
          retryParams.append("otpCode", code);

          const { data } = await Vue.axios.post("labs/visit", retryParams);
*/
      var otpCode = code;
    const {username,password}  = context;


  const user: User = await this.$store.dispatch("auth/login", {
        username,
        password,
        otpCode
      });
          if (user.message === "CODE_INVALID") {
            Swal.showValidationMessage("Incorrect code. Please try again.");
            return false;
          }

          //context.otpCode = code;
          return user;
        } catch {
          Swal.showValidationMessage("Error validating code. Please try again.");
          return false;
        }
      }
    });
  }

}
